import Api from './Api'

export default {
    get(id, keyword, pageNumber, sort) {
        return Api().get(`contribution?id=${id}&keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`contribution/${id}`);
    },
    // create(data) {
    //     return Api().post(`contribution`, data);
    // },
    // update(data) {
    //     return Api().put(`contribution/${data.id}`, data);
    // }
}